/**
 * `people` — measured. The empty pair is worded **`is not assigned`** / **`is assigned`**,
 * and the three text rows compare the assignees' rendered names.
 */
import { CONTAINS, IS_NOT_ONE_OF, IS_ONE_OF, NOT_CONTAINS, STARTS_WITH, condition, } from '../filter-conditions.js';
export const peopleFilterConditions = [
    IS_ONE_OF,
    IS_NOT_ONE_OF,
    condition('is not assigned', 'is_empty', 'none'),
    condition('is assigned', 'is_not_empty', 'none'),
    CONTAINS,
    NOT_CONTAINS,
    STARTS_WITH,
];
//# sourceMappingURL=filters.js.map